<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 596.47 596.47" style="enable-background:new 0 0 596.47 596.47;" xml:space="preserve">
        <g>
            <g>
                <g>
                    <circle fill="#0071BD" cx="269.52" cy="256.8" r="250.22"/>
                </g>
            </g>
            <g>
                <path fill="#FFFFFF" d="M407.87,246.74c0.04-0.01,0.07-0.02,0.11-0.03c7.28-1.67,12.71-8.15,12.71-15.94
                    c0-9.05-7.33-16.38-16.38-16.38c-1,0-1.97,0.12-2.92,0.29c-0.89-0.04-1.79-0.08-2.86-0.08c-41.56-0.04-83.13-0.02-124.69,0
                    c-25.35,0-50.69,0.06-76.03-0.03c-16.79-0.06-33.58-0.12-50.38-0.18c-0.45,0-0.92,0-1.38,0.02c-0.07,0-0.13-0.02-0.19-0.02
                    c-9.05,0-16.38,7.33-16.38,16.38c0,8.59,6.63,15.56,15.04,16.25c0.35,0.08,0.75,0.11,1.2,0.12c0.05,0,0.09,0.01,0.14,0.01
                    c0,0,0.01,0,0.01,0c22.68-0.09,69.55-1.01,92.22-1.04c4.61,0,8.48,0.62,8.84,6.49c2.05,33.6-7.01,63.44-31.33,87.33
                    c-14.86,14.59-39.28,36.77-63.24,51.59c-1.29,1.15-2.15,2.21-2.69,3.21c-2.34,2.83-3.81,6.42-3.81,10.38
                    c0,9.05,7.33,16.38,16.38,16.38c1.48,0,2.89-0.26,4.26-0.63c1.53-0.01,3.29-0.75,5.4-2.27c15.66-11.26,31.53-22.25,47-33.74
                    c18.84-13.99,39.18-26.05,55.43-43.4c2.05-2.19,6.43-3.71,9.41-3.28c13.39,1.93,26.68,4.61,39.98,7.15
                    c5.83,1.11,8.59,4.51,8.43,10.79c-0.31,11.99-1.48,43.96-1.38,55.95c0.07,0,0.12,0.01,0.19,0.01c0.92,8.18,7.77,14.56,16.2,14.56
                    c9.04,0,16.38-7.33,16.38-16.38c0,0,0,0,0,0c0.09-24.44-0.15-45.74-0.54-70.18c-0.08-5.11-1.74-10.48-3.83-15.22
                    c-4.62-10.49-14.63-14.16-24.52-17.74c-8.55-3.09-17.11-6.16-25.63-9.36c-4.24-1.6-5.26-4.55-4.17-9.06
                    c2.65-10.98,5.01-22.04,7.12-33.14c1.67-8.76,2.04-9.39,11.17-9.42c19.33-0.06,61.84,1.27,81.18,1.03c0,0,0.01,0,0.01,0
                    c0.01,0,0.02,0,0.03,0c1.26-0.02,2.19-0.13,2.97-0.3C407.49,246.82,407.68,246.78,407.87,246.74z"/>
            </g>
            <g>
                <g>
                    <path fill="#FFFFFF" d="M279.17,213.88c24.34-0.12,39.52-16.61,39.42-42.81c-0.1-26.97-15.83-44.58-39.73-44.47
                        c-23.24,0.11-40.02,18.99-39.78,44.78C239.33,197.11,255.25,213.99,279.17,213.88z"/>
                </g>
                <g>
                    <path fill="#0071BD" d="M278.91,222.22c-28.54,0-47.89-20.36-48.17-50.76c-0.14-15.56,5.14-29.57,14.88-39.44
                        c8.69-8.82,20.49-13.7,33.21-13.76c14.27,0.13,26.3,5.07,35.04,14.86c8.49,9.5,13.01,22.61,13.06,37.92
                        c0.11,30.95-18.62,51.04-47.72,51.18l0,0C279.11,222.22,279.01,222.22,278.91,222.22z M279.08,134.94c-0.06,0-0.12,0-0.18,0
                        c-8.37,0.04-15.77,3.08-21.41,8.79c-6.6,6.69-10.17,16.48-10.07,27.57c0.2,21.13,12.26,34.23,31.49,34.23c0.07,0,0.14,0,0.21,0
                        l0,0c19.57-0.1,31.2-12.97,31.12-34.44c-0.04-11.16-3.09-20.45-8.82-26.86C296,138.15,288.27,134.94,279.08,134.94z"/>
                </g>
            </g>
            <g>
                <path fill="#FBFBFB" d="M380.87,189.02H342.6c-3.07,0-5.56-2.49-5.56-5.56c0-3.07,2.49-5.56,5.56-5.56h38.27
                    c3.07,0,5.56,2.49,5.56,5.56C386.43,186.53,383.94,189.02,380.87,189.02z"/>
            </g>
            <g>
                <path fill="#FBFBFB" d="M218.39,189.02H176.8c-3.07,0-5.56-2.49-5.56-5.56c0-3.07,2.49-5.56,5.56-5.56h41.59
                    c3.07,0,5.56,2.49,5.56,5.56C223.95,186.53,221.46,189.02,218.39,189.02z"/>
            </g>
            <g>
                <path fill="#FBFBFB" d="M278.84,112.93c-3.07,0-5.56-2.49-5.56-5.56V75.86c0-3.07,2.49-5.56,5.56-5.56s5.56,2.49,5.56,5.56v31.51
                    C284.4,110.44,281.91,112.93,278.84,112.93z"/>
            </g>
            <g>
                <path fill="#FBFBFB" d="M330.28,137.57c-1.42,0-2.85-0.54-3.93-1.63c-2.17-2.17-2.17-5.69,0-7.86l24.64-24.64
                    c2.17-2.17,5.69-2.17,7.86,0c2.17,2.17,2.17,5.69,0,7.86l-24.64,24.64C333.13,137.03,331.71,137.57,330.28,137.57z"/>
            </g>
            <g>
                <path fill="#FBFBFB" d="M227.39,137.57c-1.42,0-2.85-0.54-3.93-1.63l-24.64-24.64c-2.17-2.17-2.17-5.69,0-7.86
                    c2.17-2.17,5.69-2.17,7.86,0l24.64,24.64c2.17,2.17,2.17,5.69,0,7.86C230.24,137.03,228.81,137.57,227.39,137.57z"/>
            </g>
        </g>
        <g>
            <path fill="#0071BD" d="M421.85,589.89l-2.23-56.18l0.12-0.07l46.85,31.84l-8.22,6.21l-11.23-8.2l-16.69,9.11l0.95,13.81
                L421.85,589.89z M429.73,563.44l9.77-5.33l-11.45-9.07L429.73,563.44z"/>
            <path fill="#0071BD" d="M500.49,539.83c-0.94,2.24-3.57,5.01-5.36,6.35c-12.29,9.17-27.34,6.06-35.99-5.53
                c-8.57-11.47-7.19-27.03,4.69-35.9c1.91-1.43,5.16-3.13,7.52-3.36l8.15,8.26c-3.34-0.12-6.87,0.71-10.17,3.18
                c-7.01,5.23-7.21,15.13-2.19,21.85c5.54,7.42,15.26,8.83,21.92,3.85c3.19-2.38,4.47-5.86,5.3-9.1L500.49,539.83z"/>
            <path fill="#0071BD" d="M480.86,492.38l23.51-23.32l6.46,6.52l-8.78,8.7l28.46,28.7l-6.37,7.13l-28.87-29.11l-9.6,9.52L480.86,492.38z
                "/>
            <path fill="#0071BD" d="M549.77,492.67l-38.8-31.8l5.15-8.11l39.25,32.16L549.77,492.67z"/>
            <path fill="#0071BD" d="M559.75,445.42l-19.49-27.15l6.2-7.43l30.72,45.81l-0.08,0.12l-54.02-9.95l4.58-9.17L559.75,445.42z"/>
            <path fill="#0071BD" d="M562.14,412.31c-0.99-1.72-3.12-5.17-4.85-6.06c-1.8-0.92-3.87-0.52-5.53,0.34l-1.19-7.51
                c2.66-1.08,5.7-1.47,8.34-0.12c3.02,1.55,5.75,7.16,7.43,10.06L562.14,412.31z"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: 'icon-activ'
    }
</script>